<template>
  <div :class="[showAppointAssess ? 'div-shade-show indexPage' : 'indexPage']">

    <div class="swiper-container header-swiper-banner header-banner-container">
      <headerCom ref="headerComDom"></headerCom>

      <div class="swiper-wrapper">
          <div class="swiper-slide swiper-slide-1">
             <div class="head-banner-content">
                <div class="head-banner-subtitle">全周期员工关系管理推广者和领导者</div>
                <div class="head-banner-title">避风岗-年度员工关系管理专家</div>
                <div class="head-banner-summary">
                  避风岗，专为企业员工关系管理问题而开发，旨在全面解决员工入职、在岗、离职全链条相关业务，最大化提高企业人效，最大化降低企业用工风险，开源节流，为企业发展赋能！
                </div>
                <div class="head-banner-btn-group">
                  <div class="head-banner-btn active" @click="toShowAppointAssess($event)">免费上门评估</div>
                  <div class="head-banner-btn" style="color:#FFF;border-color:#FFF;" @click="toQuotation($event)">获取报价</div>
                  <div class="clearboth"></div>
                </div>
              </div>

          </div>
          <div class="swiper-slide swiper-slide-2">
             <div class="head-banner-content">
                <div class="head-banner-title">避风岗-年度企业规章制度</div>
                <div class="head-banner-phrase-container">
                  <div class="head-banner-phrase">多对一人事法务团队</div>
                  <div class="head-banner-phrase">实时解读新政</div>
                  <div class="head-banner-phrase">动态更新制度</div>
                  <div class="clearboth"></div>
                  <div class="head-banner-phrase">零风险员工关系管理</div>
                  <div class="head-banner-phrase">规章制度留痕</div>
                  <div class="head-banner-phrase">线上接收学习</div>
                  <div class="clearboth"></div>
                </div>
                <div class="head-banner-btn-group">
                  <div class="head-banner-btn active" @click="toShowAppointAssess($event)">免费上门评估</div>
                  <div class="head-banner-btn" style="color:#FFF;border-color:#FFF;" @click="toQuotation($event)">获取报价</div>
                  <div class="clearboth"></div>
                </div>
              </div>

          </div>
      </div>
    </div>

    <!--
    <div class="header-banner-container">
      <headerCom ref="headerComDom"></headerCom>
      <div class="head-banner-content">
        <div class="head-banner-subtitle">全周期员工关系管理推广者和领导者</div>
        <div class="head-banner-title">避风岗-年度员工关系管理专家</div>
        <div class="head-banner-summary">
          避风岗，专为企业员工关系管理问题而开发，旨在全面解决员工入职、在岗、离职全链条相关业务，最大化提高企业人效，最大化降低企业用工风险，开源节流，为企业发展赋能！
        </div>
        <div class="head-banner-btn-group">
          <div class="head-banner-btn active" @click="toShowAppointAsses($event)">免费上门评估</div>
          <div class="head-banner-btn" @click="toQuotation($event)">获取报价</div>
          <div class="clearboth"></div>
        </div>
      </div>
    </div>
    -->
    <div class="main-container">

      <div class="main-content">
        <div class="main-article-container" v-for="(v,index) in hrData.slice(0,4)" v-if="v.articleSrc">
          <div class="main-article" @click="toArticleInfo(v.id,$event)">
            <div class="main-article-media-container">
              <img class="main-article-media-file" :src="v.articleSrc">
            </div>
            <div class="main-article-content">
              <div class="main-article-category-container">
                <div class="main-article-category" v-for="vc in v.categoryData">{{vc.name}}</div>
                <div class="clearboth"></div>
              </div>
              <div class="main-article-title">{{v.title}}</div>
              <div class="main-article-preview">{{v.content}}</div>
              <div class="main-article-browse">浏览数&nbsp;{{v.readQuantitie}}</div>
            </div>
            <div class="clearboth"></div>
          </div>
          <div class="main-article-split-line" v-if="index<3"></div>
        </div>


      </div>



      <!--全周期员工关系管理模型 -->
      <div class="main-content">
        <div class="main-banner main-banner3" style="margin-top: 0;margin-bottom: 70px">
          <div class="main-banner-img-container">
            <img class="main-banner-img" src="../assets/banner_bg_img.png" />
            <div class="main-banner-content">
              <div class="main-banner-title">企业员工关系管理问题的避风岗</div>
              <div class="main-banner-info4">
                专家顾问为您提供面对面2小时免费评估
              </div>
              <div class="main-banner-btn" @click="toShowAppointAssess($event)">
                免费上门评估
              </div>
            </div>
          </div>
          <div class="clearboth"></div>
        </div>
        <div class="main-content-title-container">
          <div class="main-content-title">全周期员工关系管理模型</div>
          <div class="clearboth"></div>
        </div>
        <div class="main-model-container">
          <div :class="v.isHide ? 'main-model-card active' : 'main-model-card'" v-for="(v, index) in modelCardData" >
            <div class="main-model-card-show">
              <div class="main-model-card-img-container">
                <img class="main-model-card-img" :src="v.picPath" />
              </div>

              <div class="main-model-card-title">{{ v.titleShow }}</div>
              <div class="main-model-card-info">{{ v.infoShow }}</div>
              <div class="clearboth"></div>
              <div class="main-model-card-btn" @click="toShowModelCard(index)">
                {{ v.btnTxt }}
                <img class="main-icon-more" src="../assets/icon_more.png" />
              </div>
              <div class="clearboth"></div>
            </div>
            <div class="main-model-card-hide active">
              <div class="main-model-card-title">{{ v.titleHide }}</div>
              <div class="main-model-card-info">
                <div class="main-model-card-info-phrase" v-for="(item2,index2) in v.infoHide">{{item2}}</div>
              </div>
              <div class="main-model-card-btn active" @click="toShowAppointAssess($event)">
                免费上门评估
              </div>
            </div>
          </div>

          <div class="clearboth"></div>
        </div>

        <div class="main-banner main-banner2">
          <div class="main-banner-img-container">
            <img class="main-banner-img" src="../assets/home_flourMajorCompliance_img.png" />
          </div>
          <div class="main-banner-content">
            <div class="main-banner-subtitle">全周期员工关系管理体系</div>
            <div class="main-banner-title">四大核心模块，360度提升企业管理，激发员工潜能</div>
            <div class="main-banner-info-container">
              <div class="main-banner-info">
                <div class="main-banner-info-title">诊断分析</div>
                <div class="main-banner-info3">企业人力资源管理诊断分析</div>
                <div class="main-banner-info3">企业当前问题所在</div>
                <div class="main-banner-info3">员工关注焦点问题</div>
                <div class="main-banner-info3">企业发展目标</div>
                <div class="main-banner-info-line"></div>
              </div>
              <div class="main-banner-info">
                <div class="main-banner-info-title">组织梳理</div>
                <div class="main-banner-info3">岗位梳理与设计</div>
                <div class="main-banner-info3">岗位分析与职能说明</div>
                <div class="main-banner-info3">岗位价值测评</div>
                <div class="main-banner-info3">岗位竞争机制设计</div>
                <div class="main-banner-info-line"></div>
              </div>
              <div class="main-banner-info">
                <div class="main-banner-info-title">留住员工</div>
                <div class="main-banner-info3">人力招聘体系构建</div>
                <div class="main-banner-info3">内部竞聘组织与实施</div>
                <div class="main-banner-info3">结构化面试</div>
                <div class="main-banner-info3">胜任力评估与素质模型</div>
                <div class="main-banner-info-line"></div>
              </div>
              <div class="main-banner-info">
                <div class="main-banner-info-title">合法合规</div>
                <div class="main-banner-info3">制度条款合法化</div>
                <div class="main-banner-info3">日常管理合规化</div>
                <div class="main-banner-info3">协议表单标准化</div>
                <div class="main-banner-info3">人事流程专业化</div>
                <!--<div class="main-banner-info-line"></div>-->
              </div>
              <div class="clearboth"></div>
            </div>
            <div class="main-banner-btn" @click="toShowAppointAssess($event)">
              免费上门评估
            </div>
          </div>

          <div class="clearboth"></div>
        </div>
      </div>
      <!--服务案例 -->
      <div class="main-content">
        <div class="main-content-title-container">
          <div class="main-content-title">服务案例</div>
          <div class="clearboth"></div>
        </div>

        <div class="main-case-container">
          <!-- 案例一 -->
          <div class="main-case">
            <div class="main-case-questioner">
              <div class="main-case-img-container">
                <img class="main-case-img" src="../assets/home_serviceCase_icon_caseOne.png" />
              </div>
              <div class="main-case-content">
                <div class="main-case-name">案例一</div>
                <div class="main-case-info-content">
                  <img class="main-case-dialog" src="../assets/dialog_box1.png" />
                  <div class="main-case-title">某加工制造公司，200人规模</div>
                  <div class="main-case-type">
                    <span>类型：</span>劳动纠纷频发
                  </div>
                  <div class="main-case-info">
                    调岗引发仲裁激增需完善制度和员工手册
                  </div>
                </div>
              </div>
              <div class="clearboth"></div>
            </div>
            <div class="main-case-answer">
              <div class="main-case-img-container">
                <img class="main-case-img" src="../assets/home_serviceCase_icon_solutionCase.png" />
              </div>
              <div class="main-case-content">
                <div class="main-case-name">解决方案</div>
                <div class="main-case-info-content">
                  <img class="main-case-dialog" src="../assets/dialog_box2.png" />
                  <div class="main-case-info">
                    导入全周期员工关系管理系统，1个月完成员工调岗流程梳理，2个月完成制度审阅排查不合规条款并进行完善和更新，<span>仲裁减少到0，人力成本降低30%</span>
                  </div>
                </div>
              </div>
              <div class="clearboth"></div>
            </div>
          </div>
          <!-- 案例二 -->
          <div class="main-case">
            <div class="main-case-questioner">
              <div class="main-case-img-container">
                <img class="main-case-img" src="../assets/home_serviceCase_icon_caseOne.png" />
              </div>
              <div class="main-case-content">
                <div class="main-case-name">案例二</div>
                <div class="main-case-info-content">
                  <img class="main-case-dialog" src="../assets/dialog_box3.png" />
                  <div class="main-case-title">某国际贸易公司，40人规模</div>
                  <div class="main-case-type"><span>类型：</span>代劳代管</div>
                  <div class="main-case-info">
                    财务岗或行政岗代管，无法解决员工入职、在职、离职全周期梳理及合同签订解聘流程
                  </div>
                </div>
              </div>
              <div class="clearboth"></div>
            </div>
            <div class="main-case-answer">
              <div class="main-case-img-container">
                <img class="main-case-img" src="../assets/home_serviceCase_icon_solutionCase.png" />
              </div>
              <div class="main-case-content">
                <div class="main-case-name">解决方案</div>
                <div class="main-case-info-content">
                  <img class="main-case-dialog" src="../assets/dialog_box4.png" />
                  <div class="main-case-info">
                    导入全周期员工关系管理系统，1个月完成交接资料收集，2个月完成全周期流程分析，排查问题，重新建立合规手续，所有档案全部完成电子化；<span>仲裁减少到0，人力成本降低40%</span >
                  </div>
                </div>
              </div>
              <div class="clearboth"></div>
            </div>
          </div>
          <!-- 案例三 -->
          <div class="main-case">
            <div class="main-case-questioner">
              <div class="main-case-img-container">
                <img class="main-case-img" src="../assets/home_serviceCase_icon_caseOne.png" />
              </div>
              <div class="main-case-content">
                <div class="main-case-name">案例三</div>
                <div class="main-case-info-content">
                  <img class="main-case-dialog" src="../assets/dialog_box5.png" />
                  <div class="main-case-title">某网络科技公司，100人规模</div>
                  <div class="main-case-type">
                    <span>类型：</span>团队不专业
                  </div>
                  <div class="main-case-info">
                    管理及技术人才保密协议和竞业限制约定
                  </div>
                </div>
              </div>
              <div class="clearboth"></div>
            </div>
            <div class="main-case-answer">
              <div class="main-case-img-container">
                <img class="main-case-img" src="../assets/home_serviceCase_icon_solutionCase.png" />
              </div>
              <div class="main-case-content">
                <div class="main-case-name">解决方案</div>
                <div class="main-case-info-content">
                  <img class="main-case-dialog" src="../assets/dialog_box6.png" />
                  <div class="main-case-info">
                    导入全周期员工关系管理系统，1个月完成现所有员工岗位及具体工作内容梳理，2个月完成保密协议和竞业限制约定条款完善和建立；<span>高级人才跳槽流动下降50%，人力成本降低60%</span>
                  </div>
                </div>
              </div>
              <div class="clearboth"></div>
            </div>
          </div>
        </div>
        <div class="main-banner main-banner1">
          <div class="main-banner-content">
            <div class="main-banner-title">全周期员工关系管理模块</div>
            <div class="main-banner-info1">
              6维度<span>+</span>多对一<span>+</span>云方案<span>+</span>365即时通
            </div>
            <div class="main-banner-info2">
              问题梳理 /定制植入 /降险提效 /新政随动 /工具赋能 /多对一服务
            </div>
            <div class="main-banner-btn" @click="toShowAppointAssess($event)">
              免费上门评估
            </div>
          </div>
          <div class="main-banner-img-container">
            <img class="main-banner-img" src="../assets/home_fullCycle_img.png" />
          </div>
          <div class="clearboth"></div>
        </div>
      </div>

      <!--五大需求场景 全周期员工关系管理轻松解决 -->
      <div class="main-content">
        <div class="main-content-title-container">
          <div class="main-content-title">五大需求场景</div>
          <div class="clearboth"></div>
          <div class="main-content-title">全周期员工关系管理轻松解决</div>
          <div class="clearboth"></div>
        </div>
        <div class="main-tag-container">
          <div class="main-tag">
            <div class="main-tag-icon-container">
              <img class="main-tag-icon" src="../assets/home_fiveScene_icon_timely.png"/>
            </div>
            <div class="main-tag-txt">及时性</div>
            <div class="clearboth"></div>
          </div>
          <div class="main-tag">
            <div class="main-tag-icon-container">
              <img class="main-tag-icon" src="../assets/home_fiveScene_icon_accurate.png" />
            </div>
            <div class="main-tag-txt">准确性</div>
            <div class="clearboth"></div>
          </div>
          <div class="main-tag">
            <div class="main-tag-icon-container">
              <img class="main-tag-icon" src="../assets/home_fiveScene_icon_authority.png" />
            </div>
            <div class="main-tag-txt">权威性</div>
            <div class="clearboth"></div>
          </div>
          <div class="main-tag">
            <div class="main-tag-icon-container">
              <img class="main-tag-icon" src="../assets/home_fiveScene_icon_presence.png" />
            </div>
            <div class="main-tag-txt">临场性</div>
            <div class="clearboth"></div>
          </div>
          <div class="main-tag">
            <div class="main-tag-icon-container">
              <img class="main-tag-icon" src="../assets/home_fiveScene_icon_effectiveness.png" />
            </div>
            <div class="main-tag-txt">节流增效降险</div>
            <div class="clearboth"></div>
          </div>
        </div>

        <div class="main-legend-container">
          <!--无专职人事-->
          <div class="main-legend-box">
            <div class="main-legend mainLegend1">
              <div class="main-legend-img-container">
                <img class="main-legend-img" src="../assets/home_fiveScene_firstIllustration_img.png" />
              </div>
              <div class="main-legend-content">
                <div class="main-legend-title-container">
                  <div class="main-legend-serial">SCENE ONE</div>
                  <div class="main-legend-title">
                    <div class="main-legend-emphasis-mark"></div>
                    无专职人事
                  </div>
                  <div class="main-legend-title">代劳代管问题多</div>
                </div>
                <div class="main-legend-contrast-container">
                  <div class="main-legend-contrast-txt">
                    纠纷风险<span>增加50%</span>
                  </div>
                  <div class="main-legend-contrast-rate">
                    <div class="main-legend-contrast-rate-whole"></div>
                    <div class="main-legend-contrast-rate-part"></div>
                  </div>
                  <div class="main-legend-contrast-txt">
                    流程控制<span>缺失80%</span>
                  </div>
                  <div class="main-legend-contrast-rate">
                    <div class="main-legend-contrast-rate-whole"></div>
                    <div class="main-legend-contrast-rate-part"></div>
                  </div>
                  <div class="main-legend-contrast-txt">
                    节流增效<span>降低60%</span>
                  </div>
                  <div class="main-legend-contrast-rate">
                    <div class="main-legend-contrast-rate-whole"></div>
                    <div class="main-legend-contrast-rate-part"></div>
                  </div>
                </div>
                <div class="main-legend-btn" @click="toShowAppointAssess($event)">
                  免费上门评估
                </div>
              </div>
              <div class="clearboth"></div>
            </div>
          </div>
          <!--有团队不专业-->

          <div class="main-legend-box">
            <div class="main-legend mainLegend2">
              <div class="main-legend-img-container">
                <img class="main-legend-img" src="../assets/home_fiveScene_secondIllustration_img.png" />
              </div>
              <div class="main-legend-content">
                <div class="main-legend-title-container">
                  <div class="main-legend-serial">SCENE TWO</div>
                  <div class="main-legend-title">
                    <div class="main-legend-emphasis-mark"></div>
                    有团队不专业
                  </div>
                  <div class="main-legend-title">费用不少问题一堆</div>
                </div>
                <div class="main-legend-contrast-container">
                  <div class="main-legend-contrast-txt">
                    成本<span>增加50%</span>
                  </div>
                  <div class="main-legend-contrast-rate">
                    <div class="main-legend-contrast-rate-whole"></div>
                    <div class="main-legend-contrast-rate-part"></div>
                  </div>
                  <div class="main-legend-contrast-txt">
                    纠纷风险<span>增加30%</span>
                  </div>
                  <div class="main-legend-contrast-rate">
                    <div class="main-legend-contrast-rate-whole"></div>
                    <div class="main-legend-contrast-rate-part"></div>
                  </div>
                  <div class="main-legend-contrast-txt">
                    合规条例<span>缺失50%</span>
                  </div>
                  <div class="main-legend-contrast-rate">
                    <div class="main-legend-contrast-rate-whole"></div>
                    <div class="main-legend-contrast-rate-part"></div>
                  </div>
                </div>
                <div class="main-legend-btn" @click="toShowAppointAssess($event)">
                  免费上门评估
                </div>
              </div>
              <div class="clearboth"></div>
            </div>
          </div>

          <!--劳资纠纷频发-->
          <div class="main-legend-box">
            <div class="main-legend mainLegend3">
              <div class="main-legend-img-container">
                <img
                  class="main-legend-img"
                  src="../assets/home_fiveScene_thirdIllustration_img.png"
                />
              </div>
              <div class="main-legend-content">
                <div class="main-legend-title-container">
                  <div class="main-legend-serial">SCENE THREE</div>
                  <div class="main-legend-title">
                    <div class="main-legend-emphasis-mark"></div>
                    劳资纠纷频发
                  </div>
                  <div class="main-legend-title">急需靠谱权威长效专家介入</div>
                </div>
                <div class="main-legend-contrast-container">
                  <div class="main-legend-contrast-txt">
                    赔偿综合成本<span>增加150%</span>
                  </div>
                  <div class="main-legend-contrast-rate">
                    <div class="main-legend-contrast-rate-whole"></div>
                    <div class="main-legend-contrast-rate-part"></div>
                  </div>
                  <div class="main-legend-contrast-txt">
                    合资合同条款<span>缺失50%</span>
                  </div>
                  <div class="main-legend-contrast-rate">
                    <div class="main-legend-contrast-rate-whole"></div>
                    <div class="main-legend-contrast-rate-part"></div>
                  </div>
                  <div class="main-legend-contrast-txt">
                    企业凝聚力<span>降低30%</span>
                  </div>
                  <div class="main-legend-contrast-rate">
                    <div class="main-legend-contrast-rate-whole"></div>
                    <div class="main-legend-contrast-rate-part"></div>
                  </div>
                </div>
                <div class="main-legend-btn" @click="toShowAppointAssess($event)">
                  免费上门评估
                </div>
              </div>
              <div class="clearboth"></div>
            </div>
          </div>
          <!--制度欠缺风险暗藏-->
          <div class="main-legend-box">
            <div class="main-legend mainLegend4">
              <div class="main-legend-img-container">
                <img
                  class="main-legend-img"
                  src="../assets/home_fiveScene_flourthIllustration_img.png"
                />
              </div>
              <div class="main-legend-content">
                <div class="main-legend-title-container">
                  <div class="main-legend-serial">SCENE EOUR</div>
                  <div class="main-legend-title">
                    <div class="main-legend-emphasis-mark"></div>
                    制度欠缺风险暗藏
                  </div>
                  <div class="main-legend-title">急待导入合规流程和制度</div>
                </div>
                <div class="main-legend-contrast-container">
                  <div class="main-legend-contrast-txt">
                    人效降低<span>增加50%</span>
                  </div>
                  <div class="main-legend-contrast-rate">
                    <div class="main-legend-contrast-rate-whole"></div>
                    <div class="main-legend-contrast-rate-part"></div>
                  </div>
                  <div class="main-legend-contrast-txt">
                    临时用工成本<span>增加40%</span>
                  </div>
                  <div class="main-legend-contrast-rate">
                    <div class="main-legend-contrast-rate-whole"></div>
                    <div class="main-legend-contrast-rate-part"></div>
                  </div>
                  <div class="main-legend-contrast-txt">
                    法律风险<span>增加30%</span>
                  </div>
                  <div class="main-legend-contrast-rate">
                    <div class="main-legend-contrast-rate-whole"></div>
                    <div class="main-legend-contrast-rate-part"></div>
                  </div>
                </div>
                <div class="main-legend-btn" @click="toShowAppointAssess($event)">
                  免费上门评估
                </div>
              </div>
              <div class="clearboth"></div>
            </div>
          </div>
          <!--新政利好未知或延迟-->
          <div class="main-legend-box">
            <div class="main-legend mainLegend5">
              <div class="main-legend-img-container">
                <img class="main-legend-img" src="../assets/home_fiveScene_fifthIllustration_img.png" />
              </div>
              <div class="main-legend-content">
                <div class="main-legend-title-container">
                  <div class="main-legend-serial">SCENE EIVE</div>
                  <div class="main-legend-title">
                    <div class="main-legend-emphasis-mark"></div>
                    新政利好未知或延迟
                  </div>
                  <div class="main-legend-title">
                    红利未得&nbsp;风险增加不知
                  </div>
                </div>
                <div class="main-legend-contrast-container">
                  <div class="main-legend-contrast-txt">
                    政策红利减免<span>少得80%</span>
                  </div>
                  <div class="main-legend-contrast-rate">
                    <div class="main-legend-contrast-rate-whole"></div>
                    <div class="main-legend-contrast-rate-part"></div>
                  </div>
                  <div class="main-legend-contrast-txt">
                    劳资风险<span>增加70%</span>
                  </div>
                  <div class="main-legend-contrast-rate">
                    <div class="main-legend-contrast-rate-whole"></div>
                    <div class="main-legend-contrast-rate-part"></div>
                  </div>
                  <div class="main-legend-contrast-txt">
                    人力成本<span>增加20%</span>
                  </div>
                  <div class="main-legend-contrast-rate">
                    <div class="main-legend-contrast-rate-whole"></div>
                    <div class="main-legend-contrast-rate-part"></div>
                  </div>
                </div>
                <div class="main-legend-btn" @click="toShowAppointAssess($event)">
                  免费上门评估
                </div>
              </div>
              <div class="clearboth"></div>
            </div>
          </div>
        </div>
      </div>



      <!--公司介绍-->
      <div class="main-content">
        <div class="main-content-title-container">
          <div class="main-content-title">公司介绍</div>
          <div class="clearboth"></div>
        </div>

        <div class="main-introduce-container">
          <div class="main-introduce-video-container">
            <img class="main-introduce-video-play" :src="videoPlayIconSrc" v-if="!videoPlay"
              @click.stop="playVideo"  @mouseenter="changeVideoIconSrc(1)" @mouseleave="changeVideoIconSrc(2)" />
            <video class="main-introduce-video" :src="videoPlay ? videoPlaySrc : ''" poster="../assets/video_poster.png"
              webkit-playsinline="true" autoplay :controls="videoPlay" playsinline="true" muted="true" loop="loop" >
              视频加载失败。
            </video>
            <div class="main-introduce-video-more-container">
              <div class="main-introduce-video-more" @click="toVideo($event)">
                查看更多视频
                <img class="main-icon-more" src="../assets/icon_more.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <foot></foot>

    <!--<popup
      v-if="showAppointAssess"
      :showAppointAssess="showAppointAssess"
      @closePop="closePop"></popup>-->

    <!--<popup v-if="showAppointAssess"  :showAppointAssess.sync="showAppointAssess"></popup>-->

    <popup
      v-if="showAppointAssess"
      :showAppointAssess="showAppointAssess"
      @closePop="closePop" @toShowAppointAssessSuccess="toShowAppointAssessSuccess"></popup>
    <popup
      v-if="showAppointAssessSuccess"
      :showAppointAssessSuccess="showAppointAssessSuccess"
      @closePop="closePop"></popup>

  </div>
</template>

<script>
import headerCom from "@/components/Header.vue";
import foot from "@/components/Footer.vue";
import popup from '@/components/popup.vue';
import Swiper from 'swiper'
import axios from "axios";


export default {
  data() {
    return {
      modelCardData: [
        {
          titleShow: "风险诊断",
          infoShow: "一次性深度诊断企业员工用工风险",
          btnTxt: "约50项",
          titleHide: "9大人事风险诊断",
          infoHide: [
            "招聘工作全过程诊断",
            "合同签订所有文件查看",
            "保险公积金基数核定审核",
            "员工考核和晋升程序",
            "薪酬福利结构及标准审核",
            "三期员工执行标准",
            "工伤及医疗期员工待遇标准",
            "解除或终止劳动合同全过程",
            "人事管理流程标准",
          ],
          picPath: require("../assets/home_managementmodel_icon_question.png"),
          isHide: false,
        },
        {
          titleShow: "制度编写",
          infoShow: "规章制度员工手册编写、修订、更新",
          btnTxt: "约130项",
          titleHide: "14项制度编写执行服务",
          infoHide: [
            "招聘管理制度",
            "企业培训制度",
            "员工入职制度",
            "员工考勤制度",
            "薪酬管理制度",
            "绩效考核制度",
            "休假管理制度",
            "奖惩管理制度",
            "竞业保密制度",
            "新公司成立制度编写",
            "老公司制度完善更新",
            "制度和员工手册民主程序",
            "不同行业不同的制度制定",
            "制度执行中留痕管理",
          ],
          picPath: require("../assets/home_managementmodel_icon_implantRegulary.png"),
          isHide: false,
        },
        {
          titleShow: "流程规范",
          infoShow: "人事操作流程规范审核及实施落地",
          btnTxt: "约50项",
          titleHide: "12项流程标准搭建",
          infoHide: [
            "员工入职流程搭建",
            "劳动合同首签流程",
            "劳动合同续签流程",
            "调岗调薪流程建立",
            "员工转正晋升流程",
            "员工违纪违规处理流程",
            "员工离职流程搭建",
            "劳动合同解除流程",
            "劳动合同终止流程",
            "人事管理审核流程",
            "流程规范后落地监管",
            "所有流程配套表格统一",
          ],
          picPath: require("../assets/home_managementmodel_icon_reduceRisk.png"),
          isHide: false,
        },
        {
          titleShow: "薪酬绩效管理",
          infoShow: "薪酬福利激励绩效考核落地",
          btnTxt: "约10项",
          titleHide: "",
          infoHide: [
            "公司内部薪酬现状分析",
            "薪酬策略分析",
            "薪酬水平调研",
            "薪酬结构拆分",
            "薪酬构成确定",
            "薪酬分配动态管理",
            "薪酬方案测算讨论交流确认",
            "薪酬福利制度编写",
            "结合公司目标拆分指标任务",
            "根据岗位及分析指标制定绩效考核方案",
            "制定一整套绩效考核配套表单",
            "配合落地执行薪酬绩效实施",
          ],
          picPath: require("../assets/home_managementmodel_icon_newPolicy.png"),
          isHide: false,
        },
        {
          titleShow: "劳动合同管理",
          infoShow: "合同签订解除变更终止风险管理",
          btnTxt: "约30项",
          titleHide: "",
          infoHide: [
            "不同人员属性选择不同合同版本",
            "编写制作不同合同协议版本",
            "劳动合同签订资料审核风险排查",
            "劳动合同执行中发生变更条款处理",
            "劳动合同终止前所有合规化操作",
            "劳动合同解除前分析测算和证据收集",
            "劳动合同台账建立更新",
          ],
          picPath: require("../assets/home_managementmodel_icon_cloudTool.png"),
          isHide: false,
        },
        {
          titleShow: "员工入离职管理",
          infoShow: "入职手续标准化离职风险预防",
          btnTxt: "服务内容",
          titleHide: "",
          infoHide: [
            "员工入职手续规范",
            "员工离职手续规范",
            "面试入职员工标准化",
            "离职流程和表格规范",
            "辞退员工离职风险测算",
            "离职员工纠纷分析协助",
            "员工花名册台账建立更新",
          ],
          picPath: require("../assets/home_managementmodel_icon_manyToOne.png"),
          isHide: false,
        },
      ],
      videoPlayIconSrc: require("../assets/icon_video_play.png"),
      activityCheckboxIconSrc: require("../assets/form_activity_icon_selected.png"),
      videoPlaySrc: require("../assets/xlh_video1.mp4"),
      videoPlay: false, //播放视频

      showAppointAssess: false,
      showAppointAssessSuccess: false,

      //免费上门预约弹窗-s
      name: "", //姓名
      phone: "", //联系电话
      contact: "", //其他联系方式
      demand: "", //需求
      isJoin: 1, //限时活动
      serviceTime: "", //上门服务时间
      //免费上门预约弹窗-e

      placeHolderTime: new Date(),
      hrData:[], //动态数据
      categoryData:[],
      articleSrc1: require("../assets/article_list_img.png"),
      articleSrc2: require("../assets/article_list_img_2.png"),
      articleSrc3: require("../assets/article_list_img_3.png"),
      articleSrc4: require("../assets/article_list_img_4.png"),
      articleSrc5: require("../assets/article_list_img_5.png"),
      articleSrc6: require("../assets/article_list_img_6.png"),
    };
  },
  components: {
    headerCom,
    foot,
    popup
  },
  created() {
    /*
    let params = {};
    params.name = 'CESHIaaaaaa';
    params.size = 10;

    axios
      .post("pilotage/appointAssess", params)
      .then((res) => {
        console.log(res)
      })
      .catch((res) => {});
    */

    /*axios
      .get("pilotage/appointAssess", {params: params})
      .then((res) => {
        console.log(res)
      })
      .catch((res) => {});*/
    /*let params = {};
    axios.get("login",params).then((res) => {

    }).catch((res) => {

    });*/
    document.title = '企业标准化管理|企业内部风险管理|员工关系管理|人事管理咨询|劳动合同纠纷|规章制度编写｜薪领航管理咨询有限公司';
    let params = {};
    params.curIndex = 0;
    params.pageSize = 10;
    axios
      .get("pilotage/articleList", {params: params})
      .then((res) => {
        if(res!=null && res.data!=null){
          for(let i=0;i<res.data.categoryData.length;i++){
            if(this.lawLabelId==res.data.categoryData[i].id){
              this.categoryData.push({id: res.data.categoryData[i].id, isChecked: true, name: res.data.categoryData[i].name})
            }else{
              this.categoryData.push({id: res.data.categoryData[i].id, isChecked: false, name: res.data.categoryData[i].name})
            }
          }

          //标签是否显示 更多 按钮
          var categoryCount = res.data.categoryData.length
          var showCategoryCount = Math.floor((window.innerWidth - 360) * 0.6 / 118) * 3 - 1
          if(categoryCount > showCategoryCount){
            this.isShowCategoryMore = true
          }

          //最大页码数
          this.maxCurIndex = Math.floor(res.data.maxCurIndex/6)
          if(res.data.maxCurIndex%this.pageSize!=0){
            this.maxCurIndex = this.maxCurIndex + 1
          }
          //分页
          if(this.curIndex>=(this.maxCurIndex-this.pageSize-1)){
            for(let i=(this.maxCurIndex-this.pageSize-1>0?this.maxCurIndex-this.pageSize-1:1);i<=this.maxCurIndex;i++){
              if(i==(this.curIndex+1)){
                this.pageData.push({page:i,isChecked:true})
              }else{
                this.pageData.push({page:i,isChecked:false})
              }
            }
          }else{
            for(let i=0;i<this.pageSize;i++){
              if(i==0){
                this.pageData.push({page:this.curIndex,isChecked:true})
              }else if(i==(this.pageSize-2)){
                this.pageData.push({page:-1,isChecked:false})
              }else if(i==(this.pageSize-1)){
                this.pageData.push({page:this.maxCurIndex,isChecked:false})
              }else{
                this.pageData.push({page:this.curIndex+i,isChecked:false})
              }
            }
          }


          for(let j=0;j<res.data.hrData.length;j++){
            let id = res.data.hrData[j].id
            let title = res.data.hrData[j].title
            let content = res.data.hrData[j].content
            let readQuantitie = 0
            if(res.data.hrData[j].readQuantitie!=null){
              readQuantitie = res.data.hrData[j].readQuantitie
            }

            let articleSrc = "";
            if(res.data.hrData[j].videoPosterPath!=null){
              articleSrc = res.data.hrData[j].videoPosterPath
            }else if(res.data.hrData[j].imgSrc!=null){
              articleSrc = res.data.hrData[j].imgSrc
            }else{
              if(id%6==0){
                articleSrc = this.articleSrc1
              }else if(id%6==1){
                articleSrc = this.articleSrc2
              }else if(id%6==2){
                articleSrc = this.articleSrc3
              }else if(id%6==3){
                articleSrc = this.articleSrc4
              }else if(id%6==4){
                articleSrc = this.articleSrc5
              }else if(id%6==5){
                articleSrc = this.articleSrc6
              }
            }

            //文章标签
            let categoryData = []
            if(res.data.hrData[j].articleLabelList!=null){
              for(let k=0;k<res.data.hrData[j].articleLabelList.length;k++){
                let categoryId = res.data.hrData[j].articleLabelList[k].lawLabelId
                let categoryName = res.data.hrData[j].articleLabelList[k].lawLabelName
                categoryData.push({id:categoryId,name:categoryName})
              }
            }

            this.hrData.push({id:id,title:title,content:content,readQuantitie:readQuantitie,categoryData:categoryData,articleSrc:articleSrc})
          }
        }
      })
      .catch((res) => {

      });
  },
  mounted() {
    let excludes = {};
    let options = {
      excludes: excludes
    }
    //console.log(options)
    Fingerprint2.get(options, function(components) {
      // 参数
      const values = components.map(function(component) {
        return component.value
      });
      // 指纹
      const murmur = Fingerprint2.x64hash128(values.join(''), 31);
      // view.innerHTML += '<p class="pp">标识 : ' + murmur + '</p>';
      sessionStorage.setItem("Finger", murmur); //存入标识值
      //console.log(murmur);
    });


    new Swiper ('.swiper-container', {
      loop: true,
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      }
    })

    document.addEventListener("click", (e) => {
      let scrollTop = document.documentElement.scrollTop;
      let x = e.x;
      let y = Math.floor(e.y + scrollTop);
      this.$refs.headerComDom.toVisitPage(this.$route.path,this.$route.path,0,0,x,y);
    });

  },
  methods: {
    //一个变反面，其他回正面
    toShowModelCard(index){
      for(let i=0;i<this.modelCardData.length;i++){
        if(index == i){
          this.modelCardData[i].isHide = true
        }else{
          this.modelCardData[i].isHide = false
        }
      }
    },
    //视频封面上播放图标，鼠标移入移除改src
    changeVideoIconSrc(key) {
      switch (key) {
        case 1:
          this.videoPlayIconSrc = require("../assets/video_page_icon_video_play.png");
          break;
        case 2:
          this.videoPlayIconSrc = require("../assets/icon_video_play.png");
          break;
      }
    },
    //视频播放
    playVideo() {
      this.videoPlay = true;
    },
    //跳转 视频页
    toVideo(e){
      let scrollTop = document.documentElement.scrollTop;
      let x = e.x;
      let y = Math.floor(e.y + scrollTop);
      this.$refs.headerComDom.toVisitPage(this.$route.path,'/video',0,0,x,y);
      this.$router.push('/video');
    },
    //跳转 获取报价页
    toQuotation(e) {
      let scrollTop = document.documentElement.scrollTop;
      let x = e.x;
      let y = Math.floor(e.y + scrollTop);
      this.$refs.headerComDom.toVisitPage(this.$route.path,'/quotation',0,0,x,y);
      this.$router.push('/quotation');
    },
    //打开 免费上门评估弹窗 弹窗
    toShowAppointAssess(e){
      let scrollTop = document.documentElement.scrollTop;
      let x = e.x;
      let y = Math.floor(e.y + scrollTop);
      this.$refs.headerComDom.toVisitPage(this.$route.path,this.$route.path,1,0,x,y);
      this.showAppointAssess = true
      document.documentElement.scrollTop = 0;
    },
    //打开 预约上门评估成功 弹窗
    toShowAppointAssessSuccess(e){
      let scrollTop = document.documentElement.scrollTop;
      let x = e.x;
      let y = Math.floor(e.y + scrollTop);
      this.$refs.headerComDom.toVisitPage(this.$route.path,this.$route.path,2,0,x,y);
      this.showAppointAssess = false;
      this.showAppointAssessSuccess = true;
      document.querySelector('body').setAttribute('style', 'width: 100%;height: 100%;overflow: hidden;');

    },
    //关闭弹窗
    closePop(){
      this.showAppointAssess = false;
      this.showAppointAssessSuccess = false;
      document.body.removeAttribute('style');
      this.toShowModelCard(-1)
    },
    //跳转动态详情页
    toArticleInfo(id,e){
      let scrollTop = document.documentElement.scrollTop;
      let x = e.x;
      let y = Math.floor(e.y + scrollTop);
      this.$refs.headerComDom.toVisitPage(this.$route.path,'/articleInfo',0,id,x,y);
      //this.$router.push({name:'articleInfo',params:{id:id}})
      this.$router.push({
        path:'/articleInfo',
        query:{
            id:id
        }
      })
    },

  },
};
</script>

<style>
.indexPage .header{
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 2;
}
.indexPage .head-banner-content{
  z-index: 2;
}

.header-swiper-banner .swiper-slide {
  height: 840px;
}
.header-swiper-banner .swiper-slide-1 {
  background: url("../assets/home_heroBanner_bg_img.png") center center;
  background-size: cover;
}
.header-swiper-banner .swiper-slide-2 {
  background: url("../assets/aboutUs_heroBanner_bg_img.png") center center;
  background-size: cover;
}

/*
.indexPage .header-banner-container {
  background: url("../assets/home_heroBanner_bg_img.png");
  background-size: cover;
  padding-bottom: 41.666%;
  *2880*1200图片高宽比*
}
*/
.indexPage .header-banner-container .head-banner-content {
  top: 196px;
  left: 100px;
  text-align: left;
  transform: none;
}

.indexPage .header-banner-container .head-banner-subtitle {
  font-size: 18px;
  line-height: 26px;
  color: #ffffff;
  font-weight: 500;
  text-align: left;
  margin: 0;
}

.indexPage .header-banner-container .head-banner-title {
  font-weight: bold;
  font-size: 48px;
  line-height: 58px;
  color: #ffffff;
  margin: 17px 0 16px 0;
  text-align: left;
}

.indexPage .header-banner-container .head-banner-summary {
  font-size: 16px;
  line-height: 24px;
  color: #f3f7fc;
  width: 455px;
}

.indexPage .header-banner-container .head-banner-btn-group {
  margin: 60px 0 0 0;
}

.indexPage .header-banner-container .head-banner-btn {
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #1055c1;
  background: transparent;
  border-radius: 10px;
  border: 2px solid #1055c1;
  margin: 0 0 0 35px;
  float: left;
  width: 180px;
  padding: 16px 0;
  font-weight: 500;
  cursor: pointer;
}

.indexPage .header-banner-container .head-banner-btn.active {
  color: #ffffff;
  background: #1055c1;
}

.indexPage .header-banner-container .head-banner-btn:first-child {
  margin-left: 0px;
}

.indexPage .header-banner-container .head-banner-phrase-container{
  margin: 20px 0 0 0;
}

.indexPage .header-banner-container .head-banner-phrase-container .head-banner-phrase{
  float: left;
  margin: 8px 20px 0 0;
  color: #ffffff;
}

.indexPage .swiper-slide.swiper-slide-2 .head-banner-content{
  top: 222px;
}


.indexPage .main-content-title {
  background: url("../assets/Line5.png") no-repeat;
  background-size: 100% 5px;
  background-position: 0% 60%;
}

.main-tag-container {
  width: calc(100% - 440px);
  margin: auto;
  background-image: linear-gradient(to right, #ffffff, #eef4fe, #ffffff);
  margin: 30px auto auto auto;
  text-align: center;
  font-size: 0px;
}

.main-tag {
  display: inline-block;
  margin: 23px 0 23px 45px;
}

.main-tag:first-child {
  margin-left: 0px;
}

.main-tag-icon-container {
  margin: 0 19px 0 0;
  float: left;
}

.main-tag-icon {
  height: 30px;
  width: auto;
}

.main-tag-txt {
  font-family: Noto Sans SC;
  font-size: 18px;
  line-height: 30px;
  color: #1055c1;
  float: left;
}

.main-legend-container {
}

.main-legend {
  margin: 90px 0 0 0;
  display: inline-block;
}

.main-legend-container .main-legend:first-child {
  margin-top: 60px;
}

.main-legend-img-container {
  float: left;
  margin: 0 110px 0 0;
}

.main-legend-img {
  height: 400px;
  width: auto;
}

.main-legend-content {
  float: left;
}

.main-legend-container
  .main-legend-box:nth-child(odd)
  .main-legend-img-container {
  margin-left: -104px;
}

.main-legend-container
  .main-legend-box:nth-child(even)
  .main-legend-img-container {
  margin-right: 0px;
  float: right;
}

.main-legend-container .main-legend-box:nth-child(even) .main-legend-content {
  margin-right: 110px;
  float: right;
}

.main-legend-box {
  text-align: center;
  width: 100%;
}

.main-legend-title-container {
}

.main-legend-serial {
  font-size: 48px;
  line-height: 70px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #f1f4f8;
  margin: 18px 0 0 -38px;
}

.main-legend-title {
  font-size: 24px;
  line-height: 36px;
  color: #333333;
  position: relative;
  text-align: left;
}

.main-legend-title-container .main-legend-title:nth-child(2) {
  margin-top: -40px;
}

.main-legend-emphasis-mark {
  position: absolute;
  left: -19.5px;
  top: 8px;
  width: 8px;
  height: 19px;
  background: #668fd0;
}

.main-legend-contrast-container {
}

.main-legend-contrast-txt {
  font-size: 14px;
  line-height: 24px;
  color: #333333;
  text-align: left;
}

.main-legend-contrast-txt span {
  color: #1055c1;
  font-size: 16px;
}

.main-legend-contrast-rate {
  margin: 8px 0 0 0;
  position: relative;
  height: 16px;
}

.main-legend-contrast-rate-whole {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 6px;
  width: 260px;
  background: #dddddd;
  border-radius: 8px;
}

.main-legend-contrast-rate-part {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 6px;
  width: 200px;
  background: #1055c1;
  border-radius: 8px;
}

.main-legend-contrast-container .main-legend-contrast-txt:first-child {
  margin-top: 0px;
}

.main-legend-btn {
  background: #1055c1;
  border-radius: 10px;
  width: 180px;
  padding: 16px 0;
  font-family: Noto Sans SC;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #ffffff;
  margin: 36px 0 0 0;
  cursor: pointer;
}

.main-legend-container
  .mainLegend1
  .main-legend-contrast-rate:nth-child(2)
  .main-legend-contrast-rate-whole {
  width: 300px;
}

.main-legend-container
  .mainLegend1
  .main-legend-contrast-rate:nth-child(4)
  .main-legend-contrast-rate-whole {
  width: 360px;
}

.main-legend-container
  .mainLegend1
  .main-legend-contrast-rate:nth-child(6)
  .main-legend-contrast-rate-whole {
  width: 320px;
}

.main-legend-container
  .mainLegend2
  .main-legend-contrast-rate:nth-child(2)
  .main-legend-contrast-rate-whole {
  width: 300px;
}

.main-legend-container
  .mainLegend2
  .main-legend-contrast-rate:nth-child(4)
  .main-legend-contrast-rate-whole {
  width: 260px;
}

.main-legend-container
  .mainLegend2
  .main-legend-contrast-rate:nth-child(6)
  .main-legend-contrast-rate-whole {
  width: 300px;
}

.main-legend-container
  .mainLegend3
  .main-legend-contrast-rate:nth-child(2)
  .main-legend-contrast-rate-whole {
  width: 500px;
}

.main-legend-container
  .mainLegend3
  .main-legend-contrast-rate:nth-child(4)
  .main-legend-contrast-rate-whole {
  width: 300px;
}

.main-legend-container
  .mainLegend3
  .main-legend-contrast-rate:nth-child(6)
  .main-legend-contrast-rate-whole {
  width: 260px;
}

.main-legend-container
  .mainLegend4
  .main-legend-contrast-rate:nth-child(2)
  .main-legend-contrast-rate-whole {
  width: 300px;
}

.main-legend-container
  .mainLegend4
  .main-legend-contrast-rate:nth-child(4)
  .main-legend-contrast-rate-whole {
  width: 280px;
}

.main-legend-container
  .mainLegend4
  .main-legend-contrast-rate:nth-child(6)
  .main-legend-contrast-rate-whole {
  width: 260px;
}

.main-legend-container
  .mainLegend5
  .main-legend-contrast-rate:nth-child(2)
  .main-legend-contrast-rate-whole {
  width: 360px;
}

.main-legend-container
  .mainLegend5
  .main-legend-contrast-rate:nth-child(4)
  .main-legend-contrast-rate-whole {
  width: 340px;
}

.main-legend-container
  .mainLegend5
  .main-legend-contrast-rate:nth-child(6)
  .main-legend-contrast-rate-whole {
  width: 240px;
}

.main-model-container {
  width: calc(100% - 160px);
  margin: auto;
  margin: 50px auto auto auto;
}

.main-model-card {
  height: auto;
  width: calc(100% / 3 - 40px);
  float: left;
  background: #ffffff;
  border: 1px solid #dddddd;
  border-radius: 20px;
  text-align: center;
  font-size: 0;
  margin: 40px 0 0 40px;
  height: 550px;
}

.main-model-container .main-model-card:nth-child(3n + 1) {
  margin-left: 0px;
}

.main-model-container .main-model-card:nth-child(-n + 3) {
  margin-top: 0px;
}

.main-model-card-img-container {
  margin: 55px 0 0 0;
}

.main-model-card-img {
  height: 165px;
  width: auto;
}

.main-model-card-title {
  font-family: Noto Sans SC;
  font-weight: bold;
  font-size: 24px;
  line-height: 31px;
  text-align: center;
  margin: 25px 0 0 0;
}

.main-model-card-info {
  font-family: Noto Sans SC;
  font-size: 16px;
  line-height: 24px;
  width: 175px;
  white-space: normal;
  height: 120px;
  margin: 30px 0 0 0;
  display: inline-block;
}

.main-model-card-btn {
  font-family: Noto Sans SC;
  font-size: 16px;
  line-height: 56px;
  text-align: center;
  color: #1055c1;
  padding: 0px 8px;
  width: 246px;
  height: 56px;
  background: #f1f4f8;
  border-radius: 8px;
  display: inline-block;
  margin: 0 0 40px 0;
  cursor: pointer;
  position: relative;
}

.main-model-card.active {
  background: #00368a;
}

.main-model-card .main-model-card-hide {
  display: none;
}

.main-model-card.active .main-model-card-hide {
  display: inline;
}

.main-model-card.active .main-model-card-show {
  display: none;
}

.main-model-card.active .main-model-card-hide .main-model-card-title {
  font-family: Noto Sans SC;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: rgb(255, 255, 255, 0.5);
  margin: 77px 0 0 0;
  display: block;
}

.main-model-card.active .main-model-card-hide .main-model-card-info {
  width: auto;
  height: 310px;
  margin: 16px 0 0 0;
  display: block;
}

.main-model-card.active .main-model-card-hide .main-model-card-info-phrase {
  font-family: Noto Sans SC;
  font-size: 15px;
  line-height: 22px;
  text-align: center;
  color: #ffffff;
}

.main-model-card.active .main-model-card-hide .main-model-card-btn {
  font-family: Noto Sans SC;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #ffffff;
  background: transparent;
  border-radius: 10px;
  border: 2px solid #1055c1;
  width: 180px;
  padding: 16px 0;
  font-weight: 500;
  cursor: pointer;
  height: auto;
  margin: 0 0 40px 0;
}

.main-case-container {
  width: calc(100% - 480px);
  margin: auto;
  margin: 45px auto auto auto;
}

.main-case {
  font-size: 0;
  margin: 24px 0 0 0;
}

.main-case-container .main-case:first-child {
  margin-top: 0px;
}

.main-case-questioner {
}

.main-case-answer {
  margin: 12px 0 0 0;
}

.main-case-img-container {
}

.main-case-img {
  width: 64px;
  height: auto;
}

.main-case-content {
  width: 60%;
}

.main-case-name {
  font-family: Noto Sans SC;
  font-size: 14px;
  line-height: 21px;
  color: #333333;
}

.main-case-info-content {
  margin: 16px 0 0 0;
  position: relative;
  display: inline-block;
}

.main-case-dialog {
  width: auto;
}

.main-case-title {
  font-family: Noto Sans SC;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #333333;
}

.main-case-type {
  font-family: Noto Sans SC;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  color: #333333;
}

.main-case-type span {
  color: #999999;
}

.main-case-info {
  font-family: Noto Sans SC;
  color: #333333;
  width: calc(100% - 62px);
}

.main-case-questioner .main-case-img-container {
  float: left;
}

.main-case-answer .main-case-img-container {
  float: right;
}

.main-case-questioner .main-case-content {
  margin: 0 0 0 14px;
  float: left;
  text-align: left;
}

.main-case-answer .main-case-content {
  margin: 0 14px 0 0;
  float: right;
  text-align: right;
}

.main-case-questioner .main-case-name {
  text-align: left;
}

.main-case-answer .main-case-name {
  text-align: right;
}

.main-case-questioner .main-case-info {
  font-size: 14px;
  line-height: 21px;
}

.main-case-answer .main-case-info {
  font-size: 16px;
  line-height: 24px;
  opacity: 0.9;
}

.main-case-answer .main-case-info span {
  font-weight: bold;
}

.main-case-questioner .main-case-title {
  position: absolute;
  top: 18px;
  left: 36px;
}

.main-case-questioner .main-case-type {
  position: absolute;
  top: 18px;
  right: 27px;
}

.main-case-questioner .main-case-info {
  position: absolute;
  top: 54px;
  left: 36px;
}

.main-case-answer .main-case-info {
  position: absolute;
  top: 16px;
  left: 24px;
  text-align: left;
}

.main-case:first-child .main-case-questioner .main-case-dialog {
  height: 96px;
}

.main-case:first-child .main-case-answer .main-case-dialog {
  height: 88px;
}

.main-case:nth-child(2) .main-case-questioner .main-case-dialog {
  height: 116px;
}

.main-case:nth-child(2) .main-case-answer .main-case-dialog {
  height: 114px;
}

.main-case:nth-child(3) .main-case-questioner .main-case-dialog {
  height: 96px;
}

.main-case:nth-child(3) .main-case-answer .main-case-dialog {
  height: 111px;
}

</style>



// WEBPACK FOOTER //
// src/pages/index.vue